import { BaseResponse, requestApi } from '~/services/api-new';

const BASE_URL = '/rest/casino/game-widget';

export type Widget = {
	playerId: string;
	widgetId: string;
	itemList: [
		{
			id: number;
			code: string;
			name: string;
			mobile: boolean;
		},
		{
			id: number;
			code: string;
			name: string;
			mobile: boolean;
		}
	];
	gameLaunch: string;
	fgImageUrlResourceKey: string;
};

const subscribe = async ({ playerId, widgetId }: Widget) => {
	try {
		const response = await requestApi<BaseResponse<number>>({
			endpoint: `${BASE_URL}/subscription`,
			method: 'POST',
			payload: { playerId, widgetId }
		});

		return response;
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error(error);
		return null;
	}
};

const unsubscribe = async ({ playerId, widgetId }: Widget) => {
	try {
		const response = await requestApi<BaseResponse<number>>({
			endpoint: `${BASE_URL}/subscription`,
			method: 'PUT',
			payload: { playerId, widgetId }
		});

		return response;
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error(error);
		return null;
	}
};

const fetchSubscriptions = async (playerId: string) => {
	try {
		const response = await requestApi<BaseResponse<Widget[]>>({
			endpoint: `${BASE_URL}/subscription?playerId=${playerId}`
		});

		return response;
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error(error);
		return null;
	}
};

export { subscribe, unsubscribe, fetchSubscriptions };
